import { TableCell, TableCellProps } from "@mui/material";
import insertObjectIf from "util/helper";
import { ReactNode, useEffect, useRef } from "react";

interface TableCellComponentProps extends TableCellProps {
  label?: string | number | ReactNode;
  type?: "header" | "body";
  hiddenBorder?: boolean;
  value?: string|number;
}

const styleHeader = {
  backgroundColor: "var(--primary-500)",
  border: "1px solid var(--white)",
  fontWeight: "bold",
};
const styleBody = {
  backgroundColor: "transparent",
  fontWeight: "normal",
};

/**
 * A component that renders a table column with a label and optional children.
 * @param {Props} props
 * TableColumn
 */
export default function TableCellComponent({
  sx,
  label,
  children,
  type = "body",
  hiddenBorder,
  value,
  ...rest
}: TableCellComponentProps) {
  const divRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (divRef.current) {
      if (value) {
        divRef.current.innerText = value.toLocaleString();
      } else if (value === 0) {
        divRef.current.innerText = "0";
      }
    }
  }, [value]);

  return (
    <TableCell
      ref={divRef}
      {...rest}
      sx={{
        ...(type === "header" ? styleHeader : styleBody),
        height: "48px",
        fontSize: { xs: "16px", md: "18px", xl: "20px" },
        color: "var(--black)",
        textAlign: "center",
        boxSizing: "border-box",
        lineHeight: "normal",
        py: "2px",
        overflow: "hidden",
        ...sx,
        ...insertObjectIf(hiddenBorder, { border: "none" }),
      }}
    >
      {label}
      {children}
    </TableCell>
  );
}
